import React, { Component } from 'react';
import './Scroll.css';

class Scroll extends Component {

  constructor(props) {
    super(props);
    this.state = {
      fadeIn: false,
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        fadeIn: true,
      });
    }, 300);
  }

  scrollToTopHandler() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }

  render() {
    const classes = this.state.fadeIn ? 'scroll show' : 'scroll hide';
    return (
      <div
        role="presentation"
        className={classes}
        onClick={this.scrollToTopHandler}
      >
        <span
          id="arrow"
          className="glyphicon glyphicon-arrow-up"
          aria-hidden="true"
        />
      </div>
    );
  }
}

export default Scroll;



// WEBPACK FOOTER //
// ./src/components/common/Scroll.js